import { useCallback, useState } from "react";
import { useObrasTopHeaderState } from "../components/hooks/obras_top_header_state";
import { useObrasCommonReports } from "../components/hooks/obras_common_reports";
import { usePageStartBootstrap } from "../../../../common/hooks/use_page_start_bootstrap";
import { processError } from "../../../../common/utils/base_error";
import { useLocation } from "react-router";
import { useDependencyInjection } from "../../../../config/di/dependency_injection_context";
import { ObraHeaderInfo } from "../../domain/models/obra_header_info";
import { useBackOrNavigate } from "../../../../common/utils/navigateUtils";
import { isValidId } from "../../../../common/utils/utils";
import { initialObrasCadastroFilters, useObrasCadastroareaFilters } from "../hooks/Obras_cadastroarea/filters";
import { useObrasCadastroareaPagination } from "../hooks/Obras_cadastroarea/pagination";
import {
  useCreateDebounceHandler,
  useDebouncedCallback,
} from "../../../../common/hooks/use_debounced_callback";
import { usePageLoader } from "../../../../common/contexts/page_content_context";
import { evaluateParamValue } from "../../../../common/utils/params_utils";
import { ObraAreaChecklist } from "../../domain/models/obra_area_checklist";
import { GridRowSelectionModel } from "@mui/x-data-grid";
import { LogTipoTabela } from "../../../../common/utils/log_tabela_tipo";
import { ObraAreaChecklistForm } from "../schemas/Obras_cadastroarea";
import { ObraAreaEmpreendimentoChecklistForm } from "../schemas/Obras_cadastroarea/create_obra_area_empreendimento";
import { StatInformation } from "../../domain/models/stat_information";
import { ExcluirObraAreaServicosForm } from "../schemas/Obras_cadastroarea/excluir_obra_area_servicos";
import { IncluirObraAreaServicosForm } from "../schemas/Obras_cadastroarea/incluir_obra_area_servicos";
import { CopiarObraAreaChecklistForm } from "../schemas/Obras_cadastroarea/copiar_obra_area_checklist";
import { useChangeHistory } from "../../../../common/hooks/use_change_history";
import { useReinspecaoEmAbertoPagination } from "../hooks/Obras_cadastroarea/pagination_reinspecao";
import { ReinspecaoEmAbertoLista } from "../../domain/models/reinspecao_em_aberto";
import { useReeinspecaoObraAreaFilters } from "../hooks/Obras_cadastroarea/filters_reinspecao";
import { ChecklistServicoDropDown } from "../../domain/models/checklist_servico_dropdown";
import { useUserAuthStore } from "../../../../stores/global/userAuth";
import { EmpreendimentoBlocoCompletoTable } from "../../../incorporacao/domain/models/empreendimentoBlocoTable";

/**
 * LoadObraChecklistAreaFuncState
 */

type LoadObraChecklistAreaFuncState = {
  id?: number;
  area?: string;
  status?: number;
  page?: number;
  rowsPerPage?: number;
};

type LoadReinspecaoEmAbertoFuncState = {
  id?: number;
  area?: string;
  idsObraChecklistServicos?: number[];

  page?: number;
  rowsPerPage?: number;
};

/**
 * useObrasCadastroareaViewModel
 */

export const useObrasCadastroareaViewModel = () => {
  const location = useLocation();

  const backOrNavigate = useBackOrNavigate();

  const debouncedRef = useCreateDebounceHandler(750);

  const {
    setPageSaving,
    pushInfoNotification,
    pushWarnNotification,
    pushErrorNotification,
  } = usePageLoader();

  const {
    commons: { getAllLogAlteracaoByParentUseCase, getAllLogAlteracaoUseCase },
    reports: { getReportFvsDinamicoUseCase },
    obras: {
      getObraHeaderInfoUseCase,
      getChecklistServicosDropDownUseCase,
      getObraChecklistServicosDropDownUseCase,
      getObraAreaChecklistDropDownUseCase,
      getAllObraAreaChecklistUseCase,
      createObraAreaChecklistUseCase,
      createObraAreaEmpreendimentoChecklistUseCase,
      updateObraAreaChecklistUseCase,
      deleteObraAreaChecklistUseCase,
      deleteLoteObraAreaChecklistUseCase,
      getStatInformationByIdObraUseCase,
      createAreaChecklistServicosUseCase,
      deleteAreaChecklistServicosUseCase,
      copyObraAreaChecklistUseCase,
      getReinspecaoEmAbertoUseCase,
    },
    incorporacao: {
      getEmpreendimentoBlocoDropdownUseCase,
      getEmpreendimentoBlocoTableUseCase,
    },
  } = useDependencyInjection();

  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [isGeneratingRelatorioDinamico, setIsGeneratingRelatorioDinamico] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>();
  const idUsuario = useUserAuthStore(state => state.idUsuario);

  const [idObra, setIdObra] = useState<number>();

  const [selectedObraHeaderInfo, setSelectedObraHeaderInfo] =
    useState<ObraHeaderInfo>();

  const [obraAreaChecklists, setObraAreaChecklists] =
    useState<ObraAreaChecklist[]>();

  const [blocosEmpreendimento, setBlocosEmpreendimento] = useState<EmpreendimentoBlocoCompletoTable[]>();

  const [statInformation, setStatInformation] = useState<StatInformation>();

  const [selectedObraAreaChecklist, setSelectedObraAreaChecklist] =
    useState<ObraAreaChecklist>();

  const obrasTopHeaderState = useObrasTopHeaderState();

  const [openObraAreaChecklist, setOpenObraAreaChecklist] = useState(false);
  const [openObraAreaEmpreendimentoChecklist, setOpenObraAreaEmpreendimentoChecklist] = useState(false);
  const [openObraAreaChecklistDelete, setOpenObraAreaChecklistDelete] = useState(false);
  const [openCopyChecklistArea, setOpenCopyChecklistArea] = useState(false);
  const [openIncluirChecklistArea, setOpenIncluirChecklistArea] =
    useState(false);
  const [openExcluirChecklistArea, setOpenExcluirChecklistArea] =
    useState(false);
  const [openObraAreaChecklistLoteDelete, setOpenObraAreaChecklistLoteDelete] =
    useState(false);

  const [obrasReportState, initializeReportState] = useObrasCommonReports({
    idObra,
  });

  const [rowSelectionModel, setRowSelectionModel] =
    useState<GridRowSelectionModel>();

  const filters = useObrasCadastroareaFilters();
  const filtersReinspecao = useReeinspecaoObraAreaFilters();

  const pagination = useObrasCadastroareaPagination();

  const [checklistServicoDropdown, setChecklistServicosDropdown] = useState<ChecklistServicoDropDown[]>();

  //TABELA DE REINSPECAO
  const reinspecaoEmAbertoPagination = useReinspecaoEmAbertoPagination();
  const [reinspecaoEmAbertoLista, setReinspecaoEmAbertoLista] = useState<
    ReinspecaoEmAbertoLista[]
  >([]);
  const [openReinspecaoEmAberto, setOpenReinspecaoEmAberto] = useState(false);

  const changeHistory = useChangeHistory({
    getAllLogAlteracaoByParentUseCase: getAllLogAlteracaoByParentUseCase,
    getAllLogAlteracaoUseCase: getAllLogAlteracaoUseCase,
    onSetError: (e) => pushErrorNotification("Erro", [e]),
  });

  /**
   * Funções de carregamento
   */

  const loadObraChecklistServicosDropDown = useCallback(
    async (
      idObra: number,
      idsObraAreaChecklist?: number[],
      usedOnly?: boolean,
    ) => {
      try {
        const obraChecklistServicos =
          await getObraChecklistServicosDropDownUseCase.getObraChecklistServicosDropDown(
            idObra,
            null,
            idsObraAreaChecklist,
            usedOnly,
          );
        useObrasCadastroareaFilters.setState({ obraChecklistServicos });
      } catch (e: unknown) {
        throw e;
      }
    },
    [getObraChecklistServicosDropDownUseCase],
  );

  const loadExcOrIncObraChecklistServicosDropDown = useCallback(
    async (
      idObra: number,
      idsObraAreaChecklist?: number[],
      usedOnly?: boolean,
    ) => {
      try {
        const excOrIncObraChecklistServicos =
          await getObraChecklistServicosDropDownUseCase.getObraChecklistServicosDropDown(
            idObra,
            null,
            idsObraAreaChecklist,
            usedOnly,
          );
        useObrasCadastroareaFilters.setState({ excOrIncObraChecklistServicos });
      } catch (e: unknown) {
        throw e;
      }
    },
    [getObraChecklistServicosDropDownUseCase],
  );

  const loadObraAreaChecklistDropDown = useCallback(
    async (idObra: number, idObraChecklistServicoIds?: number[]) => {
      try {
        const obraAreaChecklists =
          await getObraAreaChecklistDropDownUseCase.getObraAreaChecklistDropDown(
            idObra,
            idObraChecklistServicoIds,
          );
        useObrasCadastroareaFilters.setState({ obraAreaChecklists });
      } catch (e: unknown) {
        throw e;
      }
    },
    [getObraAreaChecklistDropDownUseCase],
  );

  const loadStatInformation = useCallback(
    async (id?: number) => {
      const filteredIdObra = id ?? idObra;
      const information =
        await getStatInformationByIdObraUseCase.getStatInformationByIdObra(
          filteredIdObra,
        );
      setStatInformation(information);
    },
    [idObra, getStatInformationByIdObraUseCase],
  );
  // Mesma busca da página Empreendimento_cadastro: todos os blocos do empreendimento.
  const loadBlocosEmpreendimento = useCallback(async (idEmpreendimento: number) => {
    try {
      const blocos = await getEmpreendimentoBlocoDropdownUseCase.getEmpreendimentoBlocoDropdown(idEmpreendimento);
      const tabela = blocos.length > 0
        ? await getEmpreendimentoBlocoTableUseCase.getEmpreendimentoBlocoTable(blocos.map(x => x.id))
        : null;
      setBlocosEmpreendimento(tabela?.list ?? []);
    } catch (e: unknown) {
      setBlocosEmpreendimento(undefined);
      throw new Error('Falha ao buscar blocos do empreendimento!');
    }
  }, [
    getEmpreendimentoBlocoDropdownUseCase,
    getEmpreendimentoBlocoTableUseCase,
  ]);

  const loadObraHeaderInfo = useCallback(async (id?: number) => {
    let response: ObraHeaderInfo | null;
    try {
      const filteredIdObra = id ?? idObra;
      response = await getObraHeaderInfoUseCase.getObraHeaderInfo(filteredIdObra);
      setSelectedObraHeaderInfo(response ?? undefined);
    } catch (e: unknown) {
      setSelectedObraHeaderInfo(undefined);
      throw new Error('Falha ao buscar dados da obra!');
    }

    if (response?.idEmpreendimento) {
      await loadBlocosEmpreendimento(response.idEmpreendimento);
    } else {
      setBlocosEmpreendimento(undefined);
    }
  }, [
    idObra,
    getObraHeaderInfoUseCase,
    loadBlocosEmpreendimento,
  ]);

  const loadChecklistServicosDropDown = useCallback(async () => {
    try {
      const checklistServicosDropdown = await getChecklistServicosDropDownUseCase.getChecklistServicosDropDown();
      console.log(checklistServicosDropdown);
      setChecklistServicosDropdown(checklistServicosDropdown);
    } catch (e: unknown) {
      throw new Error("Falha ao buscar dropdown de checklists!");
    }
  }, [
    getChecklistServicosDropDownUseCase,
  ]);

  /*
  const loadObraChecklistServicosDropDown = useCallback(async (idObra: number, idsObraAreaChecklist?: number[], usedOnly?: boolean) => {
    try {
      const obraChecklistServicos = await getObraChecklistServicosDropDownUseCase
        .getObraChecklistServicosDropDown(idObra, null, idsObraAreaChecklist, usedOnly);
      useObrasCadastroareaFilters.setState({ obraChecklistServicos })
      setDropdownObraChecklistServicos(obraChecklistServicos);
    } catch (e: unknown) {
      throw e;
    }
  }, [
    getObraChecklistServicosDropDownUseCase,
  ]);
  */
  const loadObraAreaChecklist = useCallback(
    async (fs?: LoadObraChecklistAreaFuncState) => {
      const filteredIdObra = fs?.id ?? idObra;
      const filteredArea = evaluateParamValue(fs?.area, filters.area);
      const filteredStatus = evaluateParamValue(fs?.status, filters.status);

      const filteredPage = fs?.page ?? pagination.page;
      const filteredRowsPerPage = fs?.rowsPerPage ?? pagination.rowsPerPage;

      await getAllObraAreaChecklistUseCase.getAllObraAreaChecklist(
        filteredIdObra,
        filteredArea,
        filteredStatus,
        filteredPage,
        filteredRowsPerPage,
      );

      setObraAreaChecklists(getAllObraAreaChecklistUseCase.items);
      pagination.setTotalItems(getAllObraAreaChecklistUseCase.totalItems);
    },
    [idObra, filters, pagination, getAllObraAreaChecklistUseCase],
  );

  const loadReinspecaoEmAberto = useCallback(
    async (fs?: LoadReinspecaoEmAbertoFuncState) => {
      const filteredIdObra = fs?.id ?? idObra;
      const filteredArea = evaluateParamValue(fs?.area, filtersReinspecao.area);
      const filteredChecklistServico = evaluateParamValue(
        fs?.idsObraChecklistServicos,
        filtersReinspecao.idsObraChecklistServicos,
      );
      const filteredPage = fs?.page ?? reinspecaoEmAbertoPagination.page;
      const filteredRowsPerPage =
        fs?.rowsPerPage ?? reinspecaoEmAbertoPagination.rowsPerPage;

      await getReinspecaoEmAbertoUseCase.getReinspecaoEmAberto(
        filteredIdObra ?? 0,
        filteredArea ?? "",
        filteredChecklistServico ?? [],

        filteredPage,
        filteredRowsPerPage,
      );

      setReinspecaoEmAbertoLista(getReinspecaoEmAbertoUseCase.items);
      reinspecaoEmAbertoPagination.setTotalItems(
        getReinspecaoEmAbertoUseCase.totalItems,
      );
    },
    [
      idObra,
      filtersReinspecao,
      reinspecaoEmAbertoPagination,
      getReinspecaoEmAbertoUseCase,
    ],
  );

  /**
   * useEffect
   */

  usePageStartBootstrap(async () => {
    try {
      const params = new URLSearchParams(location.search);
      const locationId = params.get("id") ?? null;
      const locationIdObra = locationId ? Number(locationId) : undefined;
      const jobs = [];

      setIdObra(locationIdObra);

      if (locationIdObra) {
        useObrasCadastroareaPagination.setState({ page: 1 });
        //jobs.push(loadObraChecklistServicosDropDown(locationIdObra));
        jobs.push(loadChecklistServicosDropDown());
        jobs.push(loadObraAreaChecklistDropDown(locationIdObra));
        jobs.push(initializeReportState(locationIdObra));
        jobs.push(loadObraHeaderInfo(locationIdObra));
        jobs.push(loadObraAreaChecklist({ id: locationIdObra, page: 1 }));
        jobs.push(loadStatInformation(locationIdObra));
      }
      await Promise.all(jobs);
    } catch (e: unknown) {
      setErrorMessage(processError(e, "Falha ao buscar dados da pagina!")[0]);
    }
  });

  /**
   * Eventos
   */

  const handleReload = useCallback(async () => {
    if (idObra) {
      const jobs = [];

      //jobs.push(loadObraChecklistServicosDropDown(idObra));
      jobs.push(loadChecklistServicosDropDown());
      jobs.push(initializeReportState(idObra));
      jobs.push(loadObraAreaChecklistDropDown(idObra));
      jobs.push(loadObraHeaderInfo(idObra));
      jobs.push(loadObraAreaChecklist({ id: idObra }));
      jobs.push(loadStatInformation(idObra));

      await Promise.all(jobs);
    }
  }, [
    idObra,
    initializeReportState,
    loadChecklistServicosDropDown,
    loadObraAreaChecklistDropDown,
    loadObraHeaderInfo,
    loadObraAreaChecklist,
    loadStatInformation,
  ]);

  const handleBack = useCallback(() => {
    backOrNavigate(-1, { alternativeRoute: "/Obras_lista" });
  }, [backOrNavigate]);

  const handleConfigurarServicos = useCallback(() => {
    const idEmpreendimento = selectedObraHeaderInfo?.idEmpreendimento;
    if (isValidId(idEmpreendimento)) {
      backOrNavigate(`/EmpreendimentoUnidade_cadastro?id=${idEmpreendimento}&idObra=${idObra}`, { alternativeRoute: `/Obras_cadastroarea?id=${idObra}` });
    }
  }, [
    idObra,
    selectedObraHeaderInfo,
    backOrNavigate,
  ]);

  const relatorioDianmico = useCallback(
    async (idObraAreaChecklist: number | null, gerar: boolean) => {
      if (!gerar || isGeneratingRelatorioDinamico) return;
      if (!idObra || !Number.isInteger(idObra) || idObra <= 0) {
        pushWarnNotification("Atenção", "Selecione uma obra válida para gerar o relatório.");
        return;
      }
      try {
        setIsGeneratingRelatorioDinamico(true);
        setPageSaving(true);

        const html = await getReportFvsDinamicoUseCase.getReportFvsDinamico(
          idObra,
          idUsuario,
          idObraAreaChecklist !== null ? { area: String(idObraAreaChecklist) } : undefined,
        );
        const url = URL.createObjectURL(new Blob([html], { type: "text/html;charset=utf-8" }));
        const link = document.createElement("a");
        link.href = url;
        link.download = "Relatorio_FVS.html";
        document.body.appendChild(link);
        try {
          link.click();
        } finally {
          link.remove();
          setTimeout(() => URL.revokeObjectURL(url), 60000);
        }
      } catch (e: unknown) {
        pushErrorNotification("Erro", processError(e, "Falha ao gerar o relatório dinâmico da obra!"));
      } finally {
        setIsGeneratingRelatorioDinamico(false);
        setPageSaving(false);
      }
    },
    [idObra, idUsuario, isGeneratingRelatorioDinamico, getReportFvsDinamicoUseCase,
      setPageSaving, pushWarnNotification, pushErrorNotification],
  );

  const handleOpenAreaChecklist = useCallback(
    (idObraAreaChecklist: number | null, openNewTab: boolean) => {
      if (openNewTab) {
        window.open(
          `/Obras_checklistarea?id=${idObra}&idChecklistArea=${idObraAreaChecklist}`,
          "_blank",
          "noopener,noreferrer",
        );
      } else {
        backOrNavigate(
          `/Obras_checklistarea?id=${idObra}&idChecklistArea=${idObraAreaChecklist}`,
          { alternativeRoute: `/Obras_cadastroarea?id=${idObra}` },
        );
      }
    },
    [idObra, backOrNavigate],
  );

  const handleSubmitObraAreaChecklist = useCallback(
    async (form: ObraAreaChecklistForm) => {
      if (idObra) {
        try {
          setSaving(true);
          setPageSaving(true);

          if (selectedObraAreaChecklist) {
            await updateObraAreaChecklistUseCase.updateObraAreaChecklist(
              selectedObraAreaChecklist.idObraAreaChecklist,
              form.status,
              form.area,
              form.checklists,
            );
          } else {
            await createObraAreaChecklistUseCase.createObraAreaChecklist(
              idObra,
              form.status,
              form.area,
              form.checklists,
            );
          }
          await loadObraAreaChecklist();

          setOpenObraAreaChecklist(false);

          pushInfoNotification("Sucesso", "Registro salvo com sucesso!");
        } catch (e: unknown) {
          pushErrorNotification(
            "Erro",
            processError(e, "Falha ao buscar dados da pagina!"),
          );
        } finally {
          setSaving(false);
          setPageSaving(false);
        }
      }
    },
    [
      idObra,
      selectedObraAreaChecklist,
      createObraAreaChecklistUseCase,
      updateObraAreaChecklistUseCase,
      loadObraAreaChecklist,
      pushErrorNotification,
      pushInfoNotification,
      setPageSaving,
    ],
  );

  const handleOpenObraAreaChecklistModal = useCallback(
    async (idObraAreaChecklist: number | null, openState: boolean) => {
      try {
        if (idObra) {
          if (openState) {
            setLoading(true);
            if (idObraAreaChecklist && obraAreaChecklists) {
              const obraAreaChecklist = obraAreaChecklists.find(
                (x) => x.idObraAreaChecklist === idObraAreaChecklist,
              );
              setSelectedObraAreaChecklist(obraAreaChecklist);
              await loadObraChecklistServicosDropDown(
                idObra,
                obraAreaChecklist?.idObraAreaChecklist
                  ? [obraAreaChecklist.idObraAreaChecklist]
                  : undefined,
              );
            } else {
              setSelectedObraAreaChecklist(undefined);
              await loadObraChecklistServicosDropDown(idObra);
            }
          }
        }
        setOpenObraAreaChecklist(openState);
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao buscar dados da pagina!"),
        );
      } finally {
        setLoading(false);
      }
    },
    [
      idObra,
      obraAreaChecklists,
      loadObraChecklistServicosDropDown,
      pushErrorNotification,
    ],
  );

  const handleOpenObraAreaEmpreendimentoChecklistModal = useCallback((openState: boolean) => {
    setOpenObraAreaEmpreendimentoChecklist(openState);
  }, []);

  const handleSubmitObraAreaEmpreendimentoChecklist = useCallback(async (form: ObraAreaEmpreendimentoChecklistForm) => {
    if (idObra) {
      try {
        setSaving(true);
        setPageSaving(true);

        await createObraAreaEmpreendimentoChecklistUseCase.createObraAreaEmpreendimentoChecklist(
          idObra,
          form.status,
          form.idIncorporacaoBloco,
          form.idIncorporacaoAndar,
          form.unidade,
          form.checklists,
        );

        const jobs = [
          loadObraAreaChecklist(),
          loadObraAreaChecklistDropDown(idObra),
          loadStatInformation(idObra),
        ];
        // Recarrega os blocos para a nova unidade aparecer na grade.
        if (selectedObraHeaderInfo?.idEmpreendimento) {
          jobs.push(loadBlocosEmpreendimento(selectedObraHeaderInfo.idEmpreendimento));
        }
        await Promise.all(jobs);

        setOpenObraAreaEmpreendimentoChecklist(false);

        pushInfoNotification('Sucesso', 'Registro salvo com sucesso!');
      } catch (e: unknown) {
        pushErrorNotification("Erro", processError(e, 'Falha ao salvar a área!'));
      } finally {
        setSaving(false);
        setPageSaving(false);
      }
    }
  }, [
    idObra,
    selectedObraHeaderInfo,
    createObraAreaEmpreendimentoChecklistUseCase,
    loadObraAreaChecklist,
    loadObraAreaChecklistDropDown,
    loadStatInformation,
    loadBlocosEmpreendimento,
    pushErrorNotification,
    pushInfoNotification,
    setPageSaving,
  ]);


  const handleDeleteObraAreaChecklistOpenStateModal = useCallback(
    (idObraAreaChecklist: number | null, openState: boolean) => {
      if (openState) {
        if (idObraAreaChecklist && obraAreaChecklists) {
          const obraAreaChecklist = obraAreaChecklists.find(
            (x) => x.idObraAreaChecklist === idObraAreaChecklist,
          );
          setSelectedObraAreaChecklist(obraAreaChecklist);
        } else {
          setSelectedObraAreaChecklist(undefined);
        }
      }
      setOpenObraAreaChecklistDelete(openState);
    },
    [obraAreaChecklists],
  );

  const handleDeleteObraAreaChecklistConfirm = useCallback(async () => {
    try {
      if (idObra && selectedObraAreaChecklist) {
        setSaving(true);
        setPageSaving(true);
        await deleteObraAreaChecklistUseCase.deleteObraAreaChecklist(
          selectedObraAreaChecklist.idObraAreaChecklist,
        );
        await loadObraAreaChecklist();
        setSelectedObraAreaChecklist(undefined);
        setOpenObraAreaChecklistDelete(false);
        pushInfoNotification("Sucesso", "Registro excluido com sucesso!");
      }
    } catch (e: unknown) {
      pushErrorNotification(
        "Erro",
        processError(e, "Falha ao buscar dados da pagina!"),
      );
    } finally {
      setSaving(false);
      setPageSaving(false);
    }
  }, [
    idObra,
    selectedObraAreaChecklist,
    deleteObraAreaChecklistUseCase,
    loadObraAreaChecklist,
    pushErrorNotification,
    pushInfoNotification,
    setPageSaving,
  ]);

  const handleOpenIncluirChecklistAreaModal = useCallback(
    async (openState: boolean) => {
      if (idObra) {
        if (openState) {
          try {
            setLoading(true);
            useObrasCadastroareaFilters.setState({
              excOrIncObraChecklistServicos: undefined,
            });
            await loadObraAreaChecklistDropDown(idObra);
            setOpenIncluirChecklistArea(openState);
          } catch (e: unknown) {
            pushErrorNotification(
              "Erro",
              processError(e, "Falha ao buscar dados da pagina!"),
            );
          } finally {
            setLoading(false);
          }
        } else {
          setOpenIncluirChecklistArea(openState);
        }
      }
    },
    [idObra, loadObraAreaChecklistDropDown, pushErrorNotification],
  );

  const handleObraServicosIncluirSubmit = useCallback(
    async (form: IncluirObraAreaServicosForm) => {
      try {
        setSaving(true);
        await createAreaChecklistServicosUseCase.createAreaChecklistServicos(
          form.areas,
          form.checklists,
        );
        setOpenIncluirChecklistArea(false);
        pushInfoNotification("Sucesso", "Registro salvo com sucesso!");
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao buscar dados da pagina!"),
        );
      } finally {
        setSaving(false);
      }
    },
    [
      createAreaChecklistServicosUseCase,
      pushErrorNotification,
      pushInfoNotification,
    ],
  );

  const handleOpenExcluirChecklistAreaModal = useCallback(
    async (openState: boolean) => {
      if (idObra) {
        if (openState) {
          try {
            setLoading(true);
            await loadExcOrIncObraChecklistServicosDropDown(
              idObra,
              undefined,
              true,
            );
            useObrasCadastroareaFilters.setState({
              obraAreaChecklists: undefined,
            });
            setOpenExcluirChecklistArea(openState);
          } catch (e: unknown) {
            pushErrorNotification(
              "Erro",
              processError(e, "Falha ao buscar dados da pagina!"),
            );
          } finally {
            setLoading(false);
          }
        } else {
          setOpenExcluirChecklistArea(openState);
        }
      }
    },
    [idObra, loadExcOrIncObraChecklistServicosDropDown, pushErrorNotification],
  );

  const handleObraAreaExcluirChecklistChange = useCallback(
    async (checklists: number[] | null) => {
      if (idObra) {
        try {
          setLoading(true);
          if (checklists && checklists.length > 0) {
            await loadObraAreaChecklistDropDown(
              idObra,
              checklists ?? undefined,
            );
          } else {
            useObrasCadastroareaFilters.setState({
              obraAreaChecklists: undefined,
            });
          }
        } catch (e: unknown) {
          pushErrorNotification(
            "Erro",
            processError(e, "Falha ao buscar dados da pagina!"),
          );
        } finally {
          setLoading(false);
        }
      }
    },
    [idObra, loadObraAreaChecklistDropDown, pushErrorNotification],
  );

  const handleObraServicosExcluirSubmit = useCallback(
    async (form: ExcluirObraAreaServicosForm) => {
      try {
        setSaving(true);
        await deleteAreaChecklistServicosUseCase.deleteAreaChecklistServicos(
          form.areas,
          form.checklists,
        );
        setOpenExcluirChecklistArea(false);
        pushInfoNotification("Sucesso", "Registro excluido com sucesso!");
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao buscar dados da pagina!"),
        );
      } finally {
        setSaving(false);
      }
    },
    [
      deleteAreaChecklistServicosUseCase,
      pushErrorNotification,
      pushInfoNotification,
    ],
  );

  const handleDeleteLoteObraAreaChecklistOpenStateModal = useCallback(
    (openState: boolean) => {
      if (
        openState &&
        (!rowSelectionModel || rowSelectionModel.ids.size === 0)
      ) {
        pushWarnNotification(
          "Atenção",
          "Você deve selecionar as área a serem excluidas!",
        );
        return;
      }
      setOpenObraAreaChecklistLoteDelete(openState);
    },
    [rowSelectionModel, pushWarnNotification],
  );

  const handleDeleteLoteObraAreaChecklistConfirm = useCallback(async () => {
    try {
      if (idObra) {
        setSaving(true);
        setPageSaving(true);
        await deleteLoteObraAreaChecklistUseCase.deleteLoteObraAreaChecklist(
          rowSelectionModel,
        );
        await loadObraAreaChecklist();
        setSelectedObraAreaChecklist(undefined);
        setOpenObraAreaChecklistLoteDelete(false);
        pushInfoNotification("Sucesso", "Registro excluido com sucesso!");
      }
    } catch (e: unknown) {
      pushErrorNotification(
        "Erro",
        processError(e, "Falha ao buscar dados da pagina!"),
      );
    } finally {
      setSaving(false);
      setPageSaving(false);
    }
  }, [
    idObra,
    rowSelectionModel,
    deleteLoteObraAreaChecklistUseCase,
    loadObraAreaChecklist,
    pushErrorNotification,
    pushInfoNotification,
    setPageSaving,
  ]);

  const handleOpenCopyChecklistAreaModal = useCallback(
    async (idObraAreaChecklist: number | null, openState: boolean) => {
      if (openState) {
        if (idObraAreaChecklist && obraAreaChecklists) {
          setSelectedObraAreaChecklist(
            obraAreaChecklists.find(
              (x) => x.idObraAreaChecklist === idObraAreaChecklist,
            ),
          );
        } else {
          setSelectedObraAreaChecklist(undefined);
        }
      }
      setOpenCopyChecklistArea(openState);
    },
    [obraAreaChecklists],
  );

  const handleCopyObraAreaChecklistSubmit = useCallback(
    async (form: CopiarObraAreaChecklistForm) => {
      if (selectedObraAreaChecklist) {
        try {
          setSaving(true);
          await copyObraAreaChecklistUseCase.copyObraAreaChecklist(
            selectedObraAreaChecklist.idObraAreaChecklist,
            form.area,
            form.copiarChecklist,
          );
          setOpenCopyChecklistArea(false);
          setLoading(true);
          await loadObraAreaChecklist();
          pushInfoNotification("Sucesso", "Registro copiado com sucesso!");
        } catch (e: unknown) {
          pushErrorNotification(
            "Erro",
            processError(e, "Falha ao copiar área!"),
          );
        } finally {
          setSaving(false);
          setLoading(false);
        }
      }
    },
    [
      selectedObraAreaChecklist,
      copyObraAreaChecklistUseCase,
      loadObraAreaChecklist,
      pushErrorNotification,
      pushInfoNotification,
    ],
  );

  const handleSelectedAreasChange = useCallback(
    async (areas: number[] | string[] | null) => {
      if (idObra) {
        try {
          setLoading(true);
          if (areas && areas.length > 0) {
            if (areas[0] && typeof areas[0] === "number") {
              await loadExcOrIncObraChecklistServicosDropDown(
                idObra,
                areas as number[],
              );
            } else {
              const strAreas = areas as string[];
              await loadExcOrIncObraChecklistServicosDropDown(
                idObra,
                strAreas.map((x) => Number(x)),
              );
            }
          } else {
            useObrasCadastroareaFilters.setState({
              excOrIncObraChecklistServicos: undefined,
            });
          }
        } catch (e: unknown) {
          pushErrorNotification(
            "Erro",
            processError(e, "Falha ao buscar dados da pagina!"),
          );
        } finally {
          setLoading(false);
        }
      }
    },
    [idObra, loadExcOrIncObraChecklistServicosDropDown, pushErrorNotification],
  );

  const handleAreaChange = useDebouncedCallback(
    debouncedRef,
    (area: string) => {
      useObrasCadastroareaFilters.setState({ area });
      return async () => {
        try {
          setLoading(true);
          useObrasCadastroareaPagination.setState({ page: 1 });
          await loadObraAreaChecklist({ area, page: 1 });
        } catch (e: unknown) {
          pushErrorNotification(
            "Erro",
            processError(e, "Falha ao buscar dados da pagina!"),
          );
        } finally {
          setLoading(false);
        }
      };
    },
    [loadObraAreaChecklist, pushErrorNotification],
  );

  const handleStatusChange = useDebouncedCallback(
    debouncedRef,
    (status: number) => {
      useObrasCadastroareaFilters.setState({ status });
      return async () => {
        try {
          setLoading(true);
          useObrasCadastroareaPagination.setState({ page: 1 });
          await loadObraAreaChecklist({ status, page: 1 });
        } catch (e: unknown) {
          pushErrorNotification(
            "Erro",
            processError(e, "Falha ao buscar dados da pagina!"),
          );
        } finally {
          setLoading(false);
        }
      };
    },
    [loadObraAreaChecklist, pushErrorNotification],
  );

  const handleClearFilter = useCallback(async () => {
    try {
      setLoading(true);
      useObrasCadastroareaFilters.setState({ ...initialObrasCadastroFilters });
      useObrasCadastroareaPagination.setState({ page: 1 });
      await loadObraAreaChecklist({ area: "", status: 2, page: 1 });
    } catch (e: unknown) {
      pushErrorNotification(
        "Erro",
        processError(e, "Falha ao buscar dados da pagina!"),
      );
    } finally {
      setLoading(false);
    }
  }, [loadObraAreaChecklist, pushErrorNotification]);

  const handlePageChange = useCallback(
    async (page: number) => {
      try {
        setLoading(true);
        useObrasCadastroareaPagination.setState({ page: page + 1 });
        await loadObraAreaChecklist({ page: page + 1 });
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao buscar dados da pagina!"),
        );
      } finally {
        setLoading(false);
      }
    },
    [loadObraAreaChecklist, pushErrorNotification],
  );

  const handleRowsPerPageChange = useCallback(
    async (rowsPerPage: number) => {
      try {
        setLoading(true);
        useObrasCadastroareaPagination.setState({ page: 1, rowsPerPage });
        await loadObraAreaChecklist({ page: 1, rowsPerPage });
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao buscar dados da pagina!"),
        );
      } finally {
        setLoading(false);
      }
    },
    [loadObraAreaChecklist, pushErrorNotification],
  );

  const handleRowSelectionModelChange = useCallback(
    (rows: GridRowSelectionModel) => {
      setRowSelectionModel(rows);
    },
    [],
  );

  const handleOpenChangeHistory = useCallback(
    (idTabela: number | null, tipoTabela: LogTipoTabela | null) => {
      if (idTabela && tipoTabela) {
        changeHistory.handleOpenChangeHistory(idTabela, tipoTabela, false);
      } else {
        if (idObra) {
          changeHistory.handleOpenChangeHistory(
            idObra,
            LogTipoTabela.OBRA,
            true,
          );
        }
      }
    },
    [idObra, changeHistory],
  );

  const handleOpenReinspecaoEmAbertoModal = useCallback(
    async (openState: boolean) => {
      try {
        if (openState) {
          if (idObra) {
            await loadReinspecaoEmAberto();
            setOpenReinspecaoEmAberto(true);
          }
        } else {
          setOpenReinspecaoEmAberto(false);
        }
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao abrir reinspeção em aberto!"),
        );
      }
    },
    [loadReinspecaoEmAberto, pushErrorNotification, idObra],
  );

  const handleRedirectToReinspecaoEmAberto = useCallback(
    async (
      idObra: number,
      idChecklistArea: number,
      idChecklistServico: number,
      idInspecaoObra: number,
      openNewTab: boolean,
    ) => {
      if (openNewTab) {
        window.open(
          `/ObraItensChecklistArea_verificacao?id=${idObra}&idChecklistArea=${idChecklistArea}&idChecklistServico=${idChecklistServico}&idInspecaoObra=${idInspecaoObra}`,
          "_blank",
          "noopener,noreferrer",
        );
      } else {
        backOrNavigate(
          `/ObraItensChecklistArea_verificacao?id=${idObra}&idChecklistArea=${idChecklistArea}&idChecklistServico=${idChecklistServico}&idInspecaoObra=${idInspecaoObra}`,
          {
            alternativeRoute: `/ObraItensChecklistArea_cadastro?id=${idObra}&idChecklistArea=${idChecklistArea}&idChecklistServico=${idChecklistServico}`,
          },
        );
      }
    },
    [backOrNavigate],
  );

  //#region Filters for Reinspecao Em Aberto

  const handleAreaReinspecaoChange = useDebouncedCallback(
    debouncedRef,
    (area: string) => {
      useReeinspecaoObraAreaFilters.setState({ area });
      return async () => {
        try {
          setLoading(true);
          useObrasCadastroareaPagination.setState({ page: 1 });
          await loadReinspecaoEmAberto({ area, page: 1 });
        } catch (e: unknown) {
          pushErrorNotification(
            "Erro",
            processError(e, "Falha ao buscar dados da pagina!"),
          );
        } finally {
          setLoading(false);
        }
      };
    },
    [
      useReeinspecaoObraAreaFilters,
      loadReinspecaoEmAberto,
      pushErrorNotification,
    ],
  );

  const handleIdChecklistServicoReinspecaoChange = useDebouncedCallback(
    debouncedRef,
    (newValues: number[]) => {
      useReeinspecaoObraAreaFilters.setState({
        idsObraChecklistServicos: newValues,
      });
      return async () => {
        try {
          setLoading(true);
          useObrasCadastroareaPagination.setState({ page: 1 });
          await loadReinspecaoEmAberto({
            idsObraChecklistServicos: newValues,
            page: 1,
          });
        } catch (e: unknown) {
          pushErrorNotification(
            "Erro",
            processError(e, "Falha ao buscar dados da pagina!"),
          );
        } finally {
          setLoading(false);
        }
      };
    },
    [
      useReeinspecaoObraAreaFilters,
      useObrasCadastroareaPagination,
      loadReinspecaoEmAberto,
    ],
  );

  const handleClearReinspecaoFilters = useCallback(async () => {
    useReeinspecaoObraAreaFilters.setState({
      area: "",
      idsObraChecklistServicos: [],
    });
    await loadReinspecaoEmAberto({
      area: "",
      idsObraChecklistServicos: [],
      page: 1,
    });
  }, [loadReinspecaoEmAberto]);

  const handleReinspecaoEmAbertoPageChange = useCallback(
    async (page: number) => {
      try {
        setLoading(true);
        useReinspecaoEmAbertoPagination.setState({ page: page + 1 });
        await loadReinspecaoEmAberto({ page: page + 1 });
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao buscar dados da pagina!"),
        );
      } finally {
        setLoading(false);
      }
    },
    [loadReinspecaoEmAberto, pushErrorNotification],
  );

  const handleReinspecaoEmAbertoRowsPerPageChange = useCallback(
    async (rowsPerPage: number) => {
      try {
        setLoading(true);
        useReinspecaoEmAbertoPagination.setState({ page: 1, rowsPerPage });
        await loadReinspecaoEmAberto({ page: 1, rowsPerPage });
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao buscar dados da pagina!"),
        );
      } finally {
        setLoading(false);
      }
    },
    [loadReinspecaoEmAberto, pushErrorNotification],
  );

  //#endregion

  return {
    loading,
    saving,
    isGeneratingRelatorioDinamico,
    errorMessage,
    idObra,
    selectedObraHeaderInfo: selectedObraHeaderInfo ?? null,
    blocosEmpreendimento: blocosEmpreendimento ?? [],
    obraAreaChecklists: obraAreaChecklists ?? [],
    statInformation,
    selectedObraAreaChecklist,
    obrasTopHeaderState,
    openObraAreaChecklist,
    openObraAreaEmpreendimentoChecklist,
    openObraAreaChecklistDelete,
    openCopyChecklistArea,
    openIncluirChecklistArea,
    openExcluirChecklistArea,
    openObraAreaChecklistLoteDelete,
    obrasReportState,
    rowSelectionModel,
    filters,
    filtersReinspecao,
    pagination,
    changeHistory,
    reinspecaoEmAbertoPagination,
    openReinspecaoEmAberto,
    reinspecaoEmAbertoLista: reinspecaoEmAbertoLista ?? [],
    checklistServicoDropdown: checklistServicoDropdown ?? [],
    handleReinspecaoEmAbertoPageChange,
    handleReinspecaoEmAbertoRowsPerPageChange,
    handleClearReinspecaoFilters,
    handleAreaReinspecaoChange,
    handleIdChecklistServicoReinspecaoChange,
    handleRedirectToReinspecaoEmAberto,
    handleOpenReinspecaoEmAbertoModal,
    handleReload,
    handleBack,
    relatorioDianmico,
    handleConfigurarServicos,
    handleOpenAreaChecklist,
    handleSubmitObraAreaChecklist,
    handleOpenObraAreaChecklistModal,
    handleSubmitObraAreaEmpreendimentoChecklist,
    handleOpenObraAreaEmpreendimentoChecklistModal,
    handleDeleteObraAreaChecklistOpenStateModal,
    handleDeleteObraAreaChecklistConfirm,
    handleDeleteLoteObraAreaChecklistOpenStateModal,
    handleDeleteLoteObraAreaChecklistConfirm,
    handleOpenIncluirChecklistAreaModal,
    handleObraServicosIncluirSubmit,
    handleOpenExcluirChecklistAreaModal,
    handleObraAreaExcluirChecklistChange,
    handleObraServicosExcluirSubmit,
    handleOpenCopyChecklistAreaModal,
    handleCopyObraAreaChecklistSubmit,
    handleSelectedAreasChange,
    handleAreaChange,
    handleStatusChange,
    handleClearFilter,
    handlePageChange,
    handleRowsPerPageChange,
    handleRowSelectionModelChange,
    handleOpenChangeHistory,
  };
};
